/**
 * Booking limit period fields on the API only accept null / daily / weekly (not monthly).
 * Recurrence and older UI still use "monthly" in places — normalize before POST/PUT.
 *
 * @param {unknown} value
 * @returns {"daily" | "weekly" | undefined}
 */
export function normalizeBookingLimitPeriodForApi(value) {
  if (value == null || value === "") return undefined;
  const s = String(value).toLowerCase();
  if (s === "daily" || s === "weekly") return s;
  if (s === "monthly") return "weekly";
  return "weekly";
}

export function normalizeBookingCutoff(value) {
  if (value == null || value === "") return null;
  const normalized = Number(value);
  return Number.isFinite(normalized) && normalized > 0 ? normalized : null;
}

export const BOOKING_CUTOFF_OPTIONS = [
  { value: "", label: "None" },
  { value: String(15 / 60), label: "15 min" },
  { value: String(30 / 60), label: "30 min" },
  { value: String(45 / 60), label: "45 min" },
  { value: "1", label: "1 hour" },
  { value: "2", label: "2 hours" },
  { value: "3", label: "3 hours" },
  { value: "4", label: "4 hours" },
  { value: "5", label: "5 hours" },
  { value: "24", label: "1 day (24 hours)" },
];

/**
 * @param {Record<string, unknown>} payload
 * @returns {Record<string, unknown>}
 */
export function normalizeClassBookingLimitFields(payload) {
  const out = { ...payload };
  for (const key of [
    "booking_limit_period",
    "booking_limit_time_period",
    "per_member_time_period",
  ]) {
    if (key in out && out[key] !== undefined) {
      out[key] = normalizeBookingLimitPeriodForApi(out[key]);
    }
  }
  return out;
}
